import { Button, Card, Input, Form, Tooltip, Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { ApplyStyle } from './style';
import { imgUrlHandle } from '@/utils';

import {AdminPlatEstateApi} from "gmrfid-service-intelligentIOT-api-manager"


const { Search } = Input;

const RelationModal = ({ setVisible1, setTableObj }) => {
  const [projectList, setProjectList] = useState([]);
  const [value, setValue] = useState();

  useEffect(() => {
    try {
      intelligentIOTManager.AdminPlatEstateApi.simpleList({
        searchForm: {
          keyWords: value,
        },
      }).then((res) => {
        if (res && res.status === 200) {
          setProjectList(res.data.content);
        }
      });
    } catch (err) {
      console.log(err);
    }
  }, [value]);

  const onSearch = (v) => {
    setValue(v);
  };
  return (
    <ApplyStyle>
      <div className="project-query">
        <Search className="inp" placeholder="请输入" allowClear enterButton="搜索" size="large" onSearch={onSearch} />
        <ul className="project">
          {projectList.length > 0 ? (
            projectList.map((item, index) => {
              return (
                <li key={index}>
                  <img src={item.headUrl ? imgUrlHandle(item.headUrl) : './def_organizationImg.png'} alt="" />
                  <div className="project-text">
                    <Tooltip title={item.estateName}>
                      {item.estateName.length > 20 ? `${item.estateName?.slice(0, 20)}...` : item.estateName}
                    </Tooltip>
                  </div>
                  <div
                    className="project-but"
                    onClick={() => {
                      setTableObj(item);
                      setVisible1(true);
                    }}
                  >
                    绑定
                  </div>
                </li>
              );
            })
          ) : (
            <Empty description="没有搜索到小区信息" style={{ marginTop: 60 }} />
          )}
        </ul>
      </div>
    </ApplyStyle>
  );
};

export default RelationModal;
